import { createApp } from '@app/adapters/create-app'

import WorkflowReviewSecondaryLeft from '@app/application/workflows/screens/workflow-review/components/workflow-review-subnav-secondary-left.vue'

window.onDomLoad(function ($dom) {
  $dom
    .find("[data-behaviour='workflow-review-subnav-secondary-left']")
    .each(function () {
      const data = this.dataset

      const app = createApp(WorkflowReviewSecondaryLeft, {
        allowReviews: data.allowReviews === 'true',
        ledgerId: parseInt(data.ledgerId || '0', 10),
        showSearch: data.showSearch === 'true',
        workflowId: parseInt(data.workflowId || '0', 10),
      })

      app.mount(this)
    })
})
